export default "__VITE_ASSET__mA7wINB1__"